import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import BottomNav from "./components/BottomNav.jsx";
import WelcomeOffer from "./components/WelcomeOffer.jsx";
import Home from "./pages/Home.jsx";
import Products from "./pages/Products.jsx";
import ProductDetail from "./pages/ProductDetail.jsx";
import Cart from "./pages/Cart.jsx";
import Checkout from "./pages/Checkout.jsx";
import Login from "./pages/Login.jsx";
import Signup from "./pages/Signup.jsx";
import Account from "./pages/Account.jsx";
import OrderSuccess from "./pages/OrderSuccess.jsx";
import Admin from "./pages/Admin.jsx";
import { trackApi } from "./api/client.js";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Record a page view on every route change (feeds the admin analytics).
// `void` guarantees the effect returns undefined (never the fetch Promise),
// so React never mistakes it for a cleanup function. Skips /admin — that's
// staff checking the dashboard, not a customer visit, and counting it would
// inflate the very numbers the dashboard is reporting.
// Each path is only logged once per browser session (sessionStorage) so a
// refresh of the same page doesn't re-count as a new visit, while navigating
// to a different page still does.
function VisitTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const key = `visited:${pathname}${search}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      // sessionStorage unavailable (e.g. private browsing) — track without dedup
    }
    void trackApi
      .visit({ path: pathname, query: search, referrer: document.referrer })
      .catch(() => {});
  }, [pathname, search]);
  return null;
}

// Auth pages and the admin dashboard use their own full-screen layout —
// no storefront header or footer.
const BARE_ROUTES = ["/login", "/signup", "/admin"];

export default function App() {
  const { pathname } = useLocation();
  const bare = BARE_ROUTES.includes(pathname);

  return (
    <>
      <ScrollToTop />
      <VisitTracker />
      {!bare && <Header />}
      <main className={!bare ? "has-bnav" : ""}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      {!bare && <BottomNav />}
      {/* Welcome popup — fires 2s after landing on any storefront page. Skipped
          on the bare routes, since pitching "join us" on the signup form itself
          (or over the admin dashboard) makes no sense. */}
      {!bare && <WelcomeOffer />}
    </>
  );
}
